import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import { useActions } from "../../../../hooks/useActions";
import Details from "./ActiveTabs/Details";
import useSearchParams from "../../../../hooks/useSearchParams";
import { useTranslation } from "react-i18next";
import Tab, { TabsWrapper } from "../../../Tab/Tab";
import AnimatedDetailsContainer from "../../../../share/ResultDetails/AnimatedDetailsContainer/AnimatedDetailsContainer";
import DetailsHeader from "../../../../share/ResultDetails/DetailsHeader/DetailsHeader";
import {
  DetailsContainer,
  DetailsTabContent,
  ShowOnMapButton,
  StyledDetailsActions,
} from "../../../../share/ResultDetails/DetailsScroll/DetailsScroll";
import useMobileScreen from "../../../../hooks/useMobileScreen";
import { CyberSecurityListItem } from "../../../../models/CybersecurityObject";
import { getCybersecurityIcon } from "../../../../util/cyberSecurityUtil";
import { getWebsiteFavicon } from "../../../../util/faviconUtil";
import ListViewCybersecurityMapDetails from "./ListViewCybersecurityMapDetails";

const CybersecurityMapDetails = () => {
  const { selectedObject: cybersecurity_company } = useTypedSelector(
    (state) => state.mapCybersecurityInfo
  );

  const { isDetailsActive, isListViewActive } = useTypedSelector(
    (state) => state.mapInterface
  );
  const {
    setIsDetailsActive,
    setCurrentMarker,
    setSelectedCybersecurityObject,
  } = useActions();

  const { removeQueryParam } = useSearchParams();
  const onCloseDetails = () => {
    setIsDetailsActive(false);
    setCurrentMarker({ lat: 0, lon: 0 });
    removeQueryParam("hash_id");
    setSelectedCybersecurityObject({} as CyberSecurityListItem);
  };

  const { t: tDetails } = useTranslation("translation", {
    keyPrefix: "mainPage.mapFilters.objectDetails",
  });
  const title = cybersecurity_company && cybersecurity_company?.name;

  const isMobile = useMobileScreen();

  if (!cybersecurity_company) {
    return null;
  }

  if (isListViewActive && !isMobile) {
    return (
      <ListViewCybersecurityMapDetails
        company={cybersecurity_company}
        isDetailsActive={isDetailsActive}
        onClose={onCloseDetails}
      />
    );
  }

  const faviconSrc = getWebsiteFavicon(cybersecurity_company?.website);
  const logoSrc =
    faviconSrc ??
    (cybersecurity_company
      ? getCybersecurityIcon(cybersecurity_company)
      : undefined);

  return (
    <AnimatedDetailsContainer isShown={isDetailsActive}>
      <DetailsHeader
        title={title}
        description={cybersecurity_company && cybersecurity_company?.address}
        closeDetails={onCloseDetails}
        logo={
          logoSrc ? <img src={logoSrc} alt="" width={40} height={40} /> : null
        }
      />
      <DetailsContainer>
        <TabsWrapper>
          <Tab
            isActive
            onClick={() => undefined}
            text={tDetails("details.title")}
          />
        </TabsWrapper>
        <DetailsTabContent>
          <Details key={cybersecurity_company && cybersecurity_company.name} />
        </DetailsTabContent>
        {!isMobile && (
          <StyledDetailsActions>
            <ShowOnMapButton
              lat={cybersecurity_company?.location?.lat}
              lon={cybersecurity_company?.location?.lon}
            />
          </StyledDetailsActions>
        )}
      </DetailsContainer>
    </AnimatedDetailsContainer>
  );
};

export default CybersecurityMapDetails;
